<template>
<div class="taball">
    <div class="all">
        <div style="display:flex;align-items: center;">
            <div class="title">新品推荐</div>
            <!-- <img width="15px" height="15px" src="../../../../assets/icon/icon-Optimization.png" alt=""> -->
        </div>
        <!-- <div class="more" @click="golist">
            更多
            <span><img width="100%" src="@/assets/icon/more.png" alt="" /></span>
        </div> -->
    </div>
    <ul class="products">
        <li class="classification" v-for="(item, index) in productList" :key="index" @click="detail(item.id)">
            <img class="cationimg" :src="item.pictureUrl" alt="" width="100%" />
            <div class="cationtitle">{{ item.chineseName }}</div>
            <!-- <div class="cationtext">{{ item.subtitle }}</div> -->
            <div class="cationintegral">
                <span class="cationspan">{{ item.integralNum }}积分</span>
            </div>
            <!-- <div class="exchange">立即兑换 ></div> -->
        </li>
    </ul>
</div>
</template>

<script>
import {
    queryByProductId
} from "@/api/api";
export default {
    components: {},
    props: ["cmsData"],
    data() {
        return {
            currentTab: 0,
            currentClass: 0,
            productList: [],
        };
    },
    watch: {},
    computed: {},
    methods: {
        toggleTab(current) {
            this.currentTab = current;
            this.currentClass = current;
        },
        detail(id) {
            this.$router.push({
                path: "/productDetails?id=" + id,
            });
        },
        golist() {
            this.$router.push({
                path: "/productlist",
            });
        },
        async queryProduct() {
            let tempList = [];
            this.cmsData.recommendList.map((value) => {
                tempList.push({
                    id: value.id,
                });
            });
            let params = {
                showTerminal: 1,
                showDesk: 2,
                list: tempList,
            };
            const res = await queryByProductId(params);
            this.productList = res.data;
        },
    },
    created() {},
    mounted() {
        this.queryProduct();
    },
};
</script>

<style lang="scss" scoped>
.all {
    padding: 20px;
    display: flex;
    // margin-top: 10px;
    // border-bottom: 1px #999 solid;
    justify-content: space-between;
}

.title {
    color: #333;
    font-size: 33px;
    font-weight: bold;
    text-align: center;
    // margin-bottom: 50px;
    background: url("../../../../assets/icon/recommend..png") no-repeat center;
}

.more {
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    // font-size: 30px;

    span {
        img {
            width: 40px;
            height: 40px;
            display: block;
            padding-left: 10px;
        }
    }
}

.taball {
    // background: #f7f7f7;
    padding-bottom: 20px;
}

.cationimg {
    width: 180px;
    height: 180px;
    margin: 0 auto;
    // border-radius: 30px;
}

.products {
    display: flex;
    // flex-direction: column;
    // justify-content: space-between;
    // flex-direction: row;
    // flex-wrap: wrap;
    box-sizing: border-box;
    // margin: 0 20px;
}

.classification {
    background: #fff;
    width: 20%;
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 20px;
    margin: 0 10px;
}

.cationtitle {
    padding-top: 10px;
    font-size: 28px;
    color: #111;
}

.cationtext {
    font-size: 26px;
    color: #999;
    padding-top: 10px;
}

.cationtitle,
.cationtext {
    width: 90%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.cationintegral {
    padding-top: 20px;
    // font-size: 25px;
}

.exchange {
    padding-top: 20px;
    font-size: 25px;
}

.cationspan {
    color: rgb(209, 80, 79);
    font-size: 25px;
    padding-right: 6px;
}

.tab {
    height: 90px;
}

.tab_button {
    display: flex;
}

.tab_button li {
    padding: 20px 0;
    flex: 1;
    width: 180px;
    /* height: 80px; */
    /* background: #f5f6f5; */
    cursor: pointer;
    display: inline-block;
    border-radius: 20px;
    font: 30px/50px "Microsoft Yahei";
    color: #999999;
    font-weight: 600;
    text-align: center;
}

.tab_button li.active {
    color: #dc242f;
}
</style>
